import { Button, CircularProgress, type ButtonProps } from '@mui/material';

export function LoadingButton({ loading, children, disabled, startIcon, ...rest }: ButtonProps & { loading?: boolean }) {
  return (
    <Button {...rest} disabled={disabled || loading} startIcon={loading ? <CircularProgress size={16} color="inherit" /> : startIcon}>
      {children}
    </Button>
  );
}
